import get from 'lodash/get';
import isString from 'lodash/isString';
import {isNumber} from "mythil/number";
import {trimHard} from "mythil/string";
import isArray from "lodash/isArray";
import isObject from 'lodash/isObject';
import values from 'lodash/values';
import isNil from 'lodash/isNil';

const truthyVals = ['ja', 'yes', '1', 'on', 'an', 'true', true, 1],
    falsyVals =  ['false', '', '0', 'no', 'off', 'nein', 'an', 'null', '-', null, false, 0],
    nulsyVals = ['', null, '-'];


const parseBool = (val) => {
    if(truthyVals.indexOf(val) > -1) {
        return true;
    }

    if(nulsyVals.indexOf(val) > -1) {
        return null;
    }

    if(falsyVals.indexOf(val) > -1) {
        return false;
    }

    return null;
}

const generalNormalizers = {
    text: (val) => {
        if(isNumber(val)) { return `${val}`; }
        if(!val) { return ''; }

        if(!isString(val)) {
            throw new Error('Text is expected to be a string-like value.')
        }

        return trimHard(val);
    },

    select: (val) => {
        if(isNumber(val)) {
            return val;
        }

        if(!val) {
            return null;
        }

        if (isArray(val) && val.length > 0) {
            return val[0];
        }

        return trimHard(val);
    },

    select_many: (val) => {
        if(isNil(val)) { return []; }
        if(isString(val) && val.length < 1) { return []; }
        if(!isArray(val) && isObject(val)) { val = values(val) }
        return val.filter((v) => v !== null).map((v) => parseInt(v));
    },

    bool: (val) => {
       return parseBool(val);
    },

    belongs_to: (val) => {
        if(!val) { return null; }
        if(isString(val)) {
            if(val.length < 1) { return null; }
            return parseInt(val);
        }

        return val;
    },

    belongs_to_many: (val) => {
        if(!val) { return []; }
        if(isString(val) && val.length < 1) { return []; }
        if(!isArray(val) && isObject(val)) { val = values(val) }
        return val.filter((v) => v !== null).map((v) => parseInt(v));
    },

    date: (val) => {
        if(!val || !val.length) { return null; }

        return val;
    },

    datetime: (val) => {
        if(!val || !val.length) { return null; }

        return val;

        // let date = parseGermanDate(val);
        // if(!date) { date = new Date(val); }
        //
        // return formatIsoDateTime(date);
    }
};

export const fieldValueNormalizers = {
    editField: generalNormalizers,
    filter: {
        ...generalNormalizers,
        bool: (val) => {
            if(isString(val)) {
                return val.length < 1 ? null : parseBool(val);
            }

            return parseBool(val);
        },
    }
};

export default function normalizeFieldValue(inputType, type, value) {
    return get(fieldValueNormalizers, `${inputType}.${type}`, generalNormalizers.text)(value);
};
